export const dividerTheme = {
  horizontal: {
    margin: '1rem 0',
    padding: '0 1rem',
    content: {
      padding: '0 0.5rem'
    }
  },
  vertical: {
    margin: '0 1rem',
    padding: '0.5rem 0',
    content: {
      padding: '0.5rem 0'
    }
  },
  colorScheme: {
    light: {
      root: {
        borderColor: 'rgba(0, 0, 0, 0.15)'
      },
      content: {
        background: 'transparent',
        color: '{gray.900}'
      }
    },
    dark: {
      root: {
        borderColor: 'rgba(255, 255, 255, 0.15)'
      },
      content: {
        background: 'transparent',
        color: '{gray.0}'
      }
    }
  }
};
